import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import makeStyles from '@mui/styles/makeStyles';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { BaseModalTitle } from '@monorepo/shared/src/components/common/Modals';
import { useModal } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Modal';
import EditTeachingOrderNameModal from './EditTeachingOrderNameModal';
import useTeachingOrder from 'state/hooks/use-teaching-order';
import CommonTextButton from 'components/common/CommonTextButton';

const t = (key, options?) => translate('teachingOrder', key, options);

const EditTeachingOrderNameButton: React.FC = () => {
  const classes = useStyles();
  const [, { openModal, closeModal }] = useModal();

  const [{ activeTeachingOrder }, { handleSaveName }] = useTeachingOrder();

  const handleSave = async (name) => {
    await handleSaveName(name);
    closeModal();
  };

  const handleEditNameModal = () => {
    openModal({
      Title: () => <BaseModalTitle text={t('editName')} onClose={closeModal} />,
      body: (
        <EditTeachingOrderNameModal
          onClose={closeModal}
          onSave={handleSave}
          name={activeTeachingOrder?.name}
        />
      ),
    });
  };

  return (
    <CommonTextButton
      className={classes.editButton}
      onClick={handleEditNameModal}
      icon={faPencilAlt}
      text={t('editName')}
    />
  );
};
const useStyles = makeStyles(() => ({
  editButton: {
    marginLeft: '2rem',
  },
}));

export default EditTeachingOrderNameButton;
